//Import Required Modules
import React from 'react';
import PropTypes from 'prop-types'
import { subtractColorPalette, addColorPalette } from '../../store/actions';

const AddColorPalette = (props, {store}) => {
  let startHex, endHex;
  let userWindow = store.getState().userWindow;
  let theme = store.getState().theme;

  const genRanColor = () => `#${Math.floor(Math.random()*16777215).toString(16)}`

  const addColors = () => {
      store.dispatch(addColorPalette(startHex.value, endHex.value, userWindow))
      startHex.value = genRanColor()
      endHex.value = genRanColor()
      startHex.focus()
  }

  const removeColors = () => {
    store.dispatch(subtractColorPalette())
    startHex.value = genRanColor()
    endHex.value = genRanColor()
    startHex.focus()
}

  return (
  <div>
    <p className={`add-color-content ${theme}`}>Add custom color palette</p>
    <form>
        <i className={`fa fa-minus btn-remove-color ${theme}`}
          onClick={() => removeColors()}
          title='Remove the top-most palette'></i>
        <input ref={input => startHex = input}
              type="color"
              defaultValue = '#000000'
              required/>
        <input ref={input => endHex = input}
              type="color"
              defaultValue = '#FFFFFF'
              required/>
        <i className={`fa fa-plus btn-add-color ${theme}`}
          onClick={() => addColors()}
          title='Add a new palette'></i>
      </form>
  </div>
  )
}

AddColorPalette.contextTypes = {
  store: PropTypes.object
}

export default AddColorPalette